import { useState } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Layout } from "antd";
import { useParams } from "react-router-dom";
import { useAmendmentsStore } from "@/features/journal-version-list";
import { projectQueries } from "@entities/project";
import { useCoordinator, useNavigationPosition } from "@shared/lib/hooks";
import { NavigationContracts } from "./navigation-contracts";
import { NavigationMenu } from "./navigation-menu";
import { NavigationProject } from "./navigation-project";
import "./navigation.scss";

const { Sider } = Layout;

const Navigation = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { projectId } = useCoordinator();
  const { isTitleAmendmentsForm } = useNavigationPosition();
  const { requestId } = useParams<{ requestId?: string }>();
  const currentAmendment = useAmendmentsStore((state) =>
    requestId
      ? (state.requests.find((request) => request.key === requestId) ?? null)
      : null,
  );
  const { data: project } = useSuspenseQuery(
    projectQueries.getProject({ projectId }),
  );

  if (isTitleAmendmentsForm && currentAmendment?.requestSource === "SYSTEM") {
    return null;
  }

  return (
    <Sider
      width={240}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <NavigationProject
        projectId={projectId || ""}
        collapsed={collapsed}
        projectName={project.shortName}
        projectAddress={project.addressUnstructured}
      />
      <NavigationMenu
        projectId={projectId || ""}
        integrationId={
          project.externalId ? project.externalId : project.projectId
        }
        collapsed={collapsed}
      />
      <NavigationContracts
        integrationId={
          project.externalId ? project.externalId : project.projectId
        }
        collapsed={collapsed}
      />
    </Sider>
  );
};

export default Navigation;
